module.exports = __webpack_public_path__ + "static/img/servicecenter__bg.f6457686.svg";